import { useCompanyExternalLinks } from './use-company-external-links.query';
import { useAddCompanyExternalLink } from './use-add-company-external-link.mutation';
import { useRemoveCompanyExternalLink } from './use-remove-company-external-link.mutation';
import { ExternalLinksWidget } from '@/components/external-links-widget/external-links-widget';
import { WIDGET_ROW_1_HEIGHT } from '../utils/constants';
import { useCanEditCompany } from '../../hooks/use-can-edit-company';

export const CompanyExternalLinksWidget = ({
  companyId,
  editable = true,
  height = WIDGET_ROW_1_HEIGHT,
  className,
}: {
  companyId: string | null;
  editable?: boolean;
  height?: number;
  className?: string;
}) => {
  const { data: externalLinks, isLoading } = useCompanyExternalLinks(companyId);
  const { mutateAsync: addExternalLink } = useAddCompanyExternalLink();
  const { mutateAsync: removeExternalLink } = useRemoveCompanyExternalLink();
  const canEditCompany = useCanEditCompany();

  const handleAddLink = async (link: string, title?: string | null) => {
    await addExternalLink({
      companyId: companyId ?? '',
      data: { urlValue: link, title: title ?? null },
    });
  };

  const onRemoveLink = async (id: string) =>
    await removeExternalLink({ companyId: companyId ?? '', linkId: id });

  return (
    <ExternalLinksWidget
      removeLinkHandler={onRemoveLink}
      addLinkHandler={handleAddLink}
      linksData={externalLinks ?? []}
      isLoading={isLoading}
      className={className}
      height={height}
      editable={editable}
      disabled={!canEditCompany}
      emptyStateConfig={{
        direction: 'column',
        labelAlign: 'center',
        padding: '16px 30px',
      }}
    />
  );
};
